export default __webpack_public_path__ + "468ac1bac485642738ca944ab5163fab.svg";